import { AccentuateResponse } from '@internal/backstage-plugin-accentuate-common';

import { Entity } from '@backstage/catalog-model';
import { createApiRef } from '@backstage/core-plugin-api';
import { JsonObject } from '@backstage/types';

import { JsonSchema } from './AccentuateClient';

/** @public */
export interface AccentuateApi {
  /** @public */
  getAll(): Promise<AccentuateResponse[]>;
  /** @public */
  get(entityRef: string): Promise<AccentuateResponse | undefined>;
  /** @public */
  update(entityRef: string, data: JsonObject): Promise<AccentuateResponse>;
  /** @public */
  delete(entityRef: string): Promise<void>;
  /** @public */
  getSchema(entity: Entity): JsonSchema | undefined;
  /** @public */
  refresh(entityRef: string): Promise<void>;
}

/** @public */
export const accentuateApiRef = createApiRef<AccentuateApi>({
  id: 'plugin.accentuate.api',
});
